import React from "react";

export default function SolarChatRoundDotsLinear(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      {...props}
    >
      <g fill="none" stroke="currentColor" strokeWidth={1.5}>
        <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12c0 1.6.376 3.112 1.043 4.453c.178.356.237.763.134 1.148l-.595 2.226a1.3 1.3 0 0 0 1.591 1.592l2.226-.596a1.63 1.63 0 0 1 1.148.134A9.96 9.96 0 0 0 12 22Z"></path>
        <path strokeLinecap="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01"></path>
      </g>
    </svg>
  );
}
